import { PANEL_PERMISSION_DENIED_EVENT, clearActingProducer } from 'helpers/actingProducer';

const WAITER_APP_PATTERN = /^\/[^/]+\/(garcom|estacao)/;
const DASHBOARD_PATH = '/painel';

const unauthorized = (api) => {
    api.interceptors.request.use((config) => config);

    api.interceptors.response.use((response) => response,
        (error) => {
            if (error.response.status === 401) {
                const isWaiterRoute = WAITER_APP_PATTERN.test(window.location.pathname);
                const hasWaiterToken = !!localStorage.getItem('otp_token');

                if (isWaiterRoute && hasWaiterToken) {
                    localStorage.removeItem('otp_token');
                    localStorage.removeItem('otp_user');
                    window.location.href = '/acesso';
                } else {
                    localStorage.removeItem("token");
                    clearActingProducer();
                    window.dispatchEvent(new Event('auth-token-removed'));
                }
            };

            // Quem entrou no painel por uma equipe: o acesso foi revogado (volta
            // para o site) ou só falta a permissão para essa ação (avisa e fica).
            const panelCode = error.response?.data?.code;

            if (error.response?.status === 403 && panelCode === 'panel_access_denied') {
                clearActingProducer();
                window.location.href = '/eventos';
            }

            if (error.response?.status === 403 && ['panel_permission_denied', 'panel_route_not_allowed'].includes(panelCode)) {
                window.dispatchEvent(new CustomEvent(PANEL_PERMISSION_DENIED_EVENT, { detail: error.response.data }));
            }

            // A API bloqueia rotas do painel por papel e devolve para onde mandar o usuário.
            // Só redireciona quando ele está dentro do painel, para não tirá-lo de outros fluxos.
            const redirectTo = error.response?.data?.redirect_to;

            if (error.response?.status === 403 && redirectTo && window.location.pathname.startsWith(DASHBOARD_PATH)) {
                window.location.href = redirectTo;
            }

            return Promise.reject(error);
        });
};

export default unauthorized;